import React from "react";
import * as Quill from "quill";
// import Toolbar from "quill/modules/toolbar";
import QuillBetterTable from "quill-better-table";
import htmlEditButton from "quill-html-edit-button";
import { v4 as uuidv4 } from "uuid";
// import Parchment from "parchment";
import "quill/dist/quill.snow.css";
import "quill-better-table/dist/quill-better-table.css";
import { THEME_COLORS } from "../../theme";
import "./quill.scss";
// import Footer from "./RawHtml";
const Parchment = Quill.import("parchment");

//
// const LineStyle = new Parchment.Attributor.Style('lineHeight', 'line-height', {
//       scope: Parchment.Scope.INLINE,
//              whiteList: ['10px', '12px', '16px']
//       });
// Quill.register(LineStyle, true);

const NoBorder = new Parchment.ClassAttributor("no-border", "no-border", {
	scope: Parchment.Scope.INLINE, // scope: Parchment.Scope.BLOCK,
});
// Parchment.register(NoBorder);
Quill.register(NoBorder);
// Register the new Footer format so we can use it in our editor.
// Quill.register(Footer, true);

Quill.register(
	{
		"modules/better-table": QuillBetterTable,
		"modules/htmlEditButton": htmlEditButton,
	},
	true
);

const CUSTOM_FORMATS_CONST = ["h1Highlighted", "no-border"] as const;
type CustomFormatsTuple = typeof CUSTOM_FORMATS_CONST;
export type CustomFormat = CustomFormatsTuple[number];

// register a format but also add to formats
const Embed = Quill.import("blots/block/embed");
const Inline = Quill.import("blots/inline");
const Block: any = Quill.import("blots/block"); // (ReactQuill as any)

// const CustomClass = new (ReactQuill as any).Quill.Parchment.Attributor.Class("custom", "ql-custom", {
// 	scope: (ReactQuill as any).Quill.Parchment.Scope.INLINE,
// });
// Quill.register(CustomClass, true);

class H1Highlighted extends Block {}
H1Highlighted.blotName = "h1Highlighted";
H1Highlighted.tagName = "h1";
H1Highlighted.className = "highlighted";

Quill.register({
	"formats/h1Highlighted": H1Highlighted,
});
Quill.register({
	"formats/h1Highlighted": H1Highlighted,
});

type QuillEditorProps = {
	text?: string;
	onChange?: (text: string) => any;
	placeholder?: string;
	showPreview?: boolean;
	showRaw?: boolean;
};

//  configure both kinds of lists - checkmark and arrow.

// https://www.npmjs.com/package/react-quill#quick-start
// TODO:  choose format. either html or delta.
//  Use editor.getContents() during the event to obtain a Delta of the full document instead.
// uncontrolled - Pass defaultValue instead of value if you need to use DOM or Quill APIs to imperatively manipulate the editor state.
class QuillEditor extends React.Component<QuillEditorProps> {
	private quillRef;
	private quill;
	private readonly uuid: string = uuidv4();

	state = {
		text: this.props.text || "",
	};
	// https://quilljs.com/docs/formats/
	formats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"blockquote",
		"color",
		"background",
		"font",
		"size",
		"align",
		"direction",
		"code",
		"code-block",
		"script",
		"list",
		"bullet",
		"ordered",
		"indent",
		"link",
		"image",
		"video",
		"hr",
		...CUSTOM_FORMATS_CONST,
		// font - don't want them to change it
	];

	componentDidMount() {
		// Quill.register(
		// 	{
		// 		"modules/better-table": QuillBetterTable,
		// 	},
		// 	true
		// );
		this.quill = new Quill(`#quillEditor-${this.uuid}`, {
			// debug:  "log",
			theme: "snow",
			placeholder: this.props.placeholder || "",
			// formats: this.formats,
			modules: {
				table: false,
				"better-table": {
					operationMenu: {
						items: {
							unmergeCells: {
								text: "Another unmerge cells name",
							},
						},
						color: {
							colors: [
								"white",
								"#f8f9fa",
								"#e9ecef",
								"#dee2e6",
								"#ced4da",
								...Object.values(THEME_COLORS),
								"#ebc080",
							],
							text: "Background Colors:",
						},
					},
				},
				htmlEditButton: {
					debug: true, // logging, default:false
					msg: "Edit the content in HTML format", //Custom message to display in the editor, default: Edit HTML here, when you click "OK" the quill editor's contents will be replaced
					okText: "Ok", // Text to display in the OK button, default: Ok,
					cancelText: "Cancel", // Text to display in the cancel button, default: Cancel
					buttonHTML: "&lt;&gt;", // Text to display in the toolbar button, default: <>
					buttonTitle: "Show HTML source", // Text to display as the tooltip for the toolbar button, default: Show HTML source
					syntax: false, // Show the HTML with syntax highlighting. Requires highlightjs on window.hljs (similar to Quill itself), default: false
					prependSelector: "div.ui-modal-content", // a string used to select where you want to insert the overlayContainer, default: null (appends to body),
					editorModules: {}, // The default mod
				},
				keyboard: {
					bindings: QuillBetterTable.keyboardBindings,
				},
				toolbar: {
					container: [
						[{ header: [1, 2, 3, 4, false] }],
						// ["h1-highlight-heading"],
						["h1Highlighted"],
						// [{ header: 1 }, { header: 2 }, { header: 3 }, { header: 4 }],
						[
							{ color: Object.values(THEME_COLORS) },
							{ background: Object.values(THEME_COLORS) },
							{ size: [] },
							// { font: [] },
						],
						["bold", "italic", "underline", "strike", "blockquote", "direction"],
						[{ align: [] }],
						[{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
						["better-table"],
						["no-border"],
						["link", "image", "video"],
						// ["hr"], TODO
						// [{ 'direction': 'rtl' }],
						// ["code", "code-block", "script"],
						// ["footer"], // inject custom html. cool but not what i meant... https://stackoverflow.com/questions/44768980/insert-raw-html-code-to-quill
						["clean"],
					],
					handlers: {
						"better-table": (value) => {
							this.insertTable();
						},
						image: this.imageHandler.bind(this),
						// footer: this.footerHandler.bind(this),
					},
				},
			},
		});

		this.quill.root.innerHTML = this.props.text;

		this.quill.on("text-change", (delta, source) => {
			console.log("text-change"); // this.quill, delta, source, this.quill.getContents(), this.quill.getText()
			if (source == "api") {
				console.log("An API call triggered this change.");
			} else if (source == "user") {
				console.log("A user action triggered this change.");
			}
			setTimeout(() => {
				const html = this.quill.root.innerHTML.split("  ").join(" &nbsp;");
				this.setState({ text: html });
				if (this.props.onChange) {
					this.props.onChange(html);
				}
				// (document.getElementById("raw-textarea") as any).value = html;
			}, 300);
		});
	}

	// shouldComponentUpdate(nextProps, nextState): boolean {
	// 	return false;
	// }

	// componentDidUpdate(prevProps: QuillEditorProps, prevState, snapshot) {
	// 	if (this.props.text !== this.state.text) {
	// 		this.setState({ text: this.props.text });
	// 	}
	// }

	formatCustom(format: CustomFormat, value) {
		console.log("formatCustom:", format, value);
		const quill = this.quillRef.getEditor();
		const range = quill.getSelection();
		if (!range) {
			alert("Select text to format");
			return;
		}
		quill.format(format, value);
	}

	imageHandler() {
		const range = this.quill.getSelection();
		const value = prompt("What is the image URL");
		this.quill.insertEmbed(range.index, "image", value, Quill.sources.USER);
	}

	footerHandler() {
		// Get the cursor location to know where footer will be added.
		var index = this.quill.getSelection(true).index;

		var footerHTML = "<h1>Footer</h1>" + "<p>This is our new footer</p>";
		// Insert the footer with the footerHTML.
		this.quill.insertEmbed(index, "footer", footerHTML);
	}

	customButtonHandler() {
		const quill = this.quillRef.getEditor();
		const range = quill.getSelection();
		if (!range) return;

		// index, text:string, format, value, source = user / api
		// quill.insertText(quill.getSelection().index, "Hello", "link", "https://world.com");
		// quill.insertText(quill.getSelection().index, " Heading 123", "h1Highlighted");

		quill.format("h1Highlighted", true);
		// quill.insertEmbed(range.index, "h1Highlighted", "what");
		// quill.format("em", true);

		// quill.insertEmbed(quill.getSelection().index, "div", { id: "123" }, "user");
		// const html = "<h1>Banana</h1>";
		// const delta = quill.clipboard.convert(html);
		// quill.setContents(delta, "silent");

		console.log(quill.getText());
		// const range = quill.getSelection();
		// if (range) {
		//   quill.insertText(range.index, "Ω  this");
		// }
	}

	insertTable() {
		const tableModule = this.quill.getModule("better-table");
		tableModule.insertTable(3, 3);
	}

	// give them their header as a button, styled class Quill.Delta Quill.Sources
	handleChange(content: string, delta, source, editor) {
		// this.setState({ text: content });
		console.log("QuillEditor change:", content, editor);

		const quill = this.quillRef.getEditor();
		if (quill.getFormat().custom) {
			// customButton.classList.add('ql-active');
		} else {
			// customButton.classList.remove('ql-active');
		}
	}

	render() {
		return (
			<>
				<div className="quill-editor cms-content">
					<div
						id={`quillEditor-${this.uuid}`}
						className="cms-content"
						// dangerouslySetInnerHTML={{ __html: this.props.text }}
					></div>
				</div>
				{this.props.showRaw && (
					<div className="clearfix w-100">
						<h4 className="mt-4 mb-2">Raw Content</h4>
						<textarea
							id="raw-textarea"
							className="w-100"
							defaultValue={this.state.text}
							style={{ height: "300px" }}
							onChange={(e) => {
								console.log("onChange", e);
								this.setState({ text: e.target.value });
								this.quill.root.innerHTML = e.target.value;
							}}
						/>
					</div>
				)}
				{this.props.showPreview && (
					<div className="clearfix my-4 w-100 cms-content">
						<h4 className="mb-3">Preview Content</h4>
						<div dangerouslySetInnerHTML={{ __html: this.state.text }} />
					</div>
				)}
			</>
		);
	}
}

export default QuillEditor;

// https://quilljs.com/0.20/docs/api/
// you can add custom module
// add format
// editor.addFormat('strike', { tag: 'S', prepare: 'strikeThrough' });
// maybe I can use that to create a custom list / heading
// editor.setHTML('<div>Hello</div>');
// insert image
// editor.insertEmbed(10, 'image', 'https://quilljs.com/images/cloud.png');

// selection changed:
// editor.on('selection-change', function(range) {
// 	if (range) {
// 	  if (range.start == range.end) {
// 		console.log('User cursor is on', range.start);
// 	  } else {
// 		var text = editor.getText(range.start, range.end);
// 		console.log('User has highlighted', text);
// 	  }
// 	} else {
// 	  console.log('Cursor not in the editor');
// 	}
//   });

// https://codepen.io/alexkrolick/pen/PWrKdx
// https://github.com/quilljs/parchment#registry

// lots of blot examples:
// https://quilljs.com/guides/cloning-medium-with-parchment/

// with twitter example
// https://codepen.io/quill/pen/vKrBjE
// https://github.com/quilljs/quill/tree/develop/formats

// imageHandler() {
//     const input = document.createElement('input');
//     input.setAttribute('type', 'file');
//     input.setAttribute('accept', 'image/*');
//     input.click();
//     input.onchange = async function() {
//       const file = input.files[0];
//       console.log('User trying to uplaod this:', file);

//       const id = await uploadFile(file); // I'm using react, so whatever upload function
//       const range = this.quill.getSelection();
//       const link = `${ROOT_URL}/file/${id}`;

//       // this part the image is inserted
//       // by 'image' option below, you just have to put src(link) of img here.
//       this.quill.insertEmbed(range.index, 'image', link);
//     }.bind(this); // react thing
//   }

// https://github.com/quilljs/quill/issues/2034
// https://github.com/quilljs/parchment#class-attributor
// https://github.com/quilljs/parchment
// https://codepen.io/moghya/pen/wmKLYR
// https://stackoverflow.com/questions/49247878/how-to-add-css-class-to-a-quill-selection
